<template>
  <div>
      <MasterHeader
        v-bind:classHeader="'registration'"
        v-bind:classGrid="'wp1200'"
        v-bind:showToastError="showToastError"
        v-bind:showToastMessage="showToastMessage"/>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration one passReset">
          <h4>{{ $t("password_reset.title") }}</h4>
          <p>{{ $t("password_reset.text") }}</p>
          <form action="#" class="custom-form">
            
            <div class="form-group" v-bind:class="{ 'not-empty': !isEmailEmpty }">
              <input
                type="text"
                class="form-control"
                name="email"
                id="email"
                v-model="form.email"
                required
                @blur="formUtilsCheckEmail()"
              />
              <label for="email" class="animated-label">{{ $t("login.email") }}</label>
              <span class="line"></span>
            </div>
            <span
              class="errorSexTxt"
              v-if="errors.email"
              for="email"
            >{{ $t("error.reset_password_email_valid") }}</span>
            
            <div class="next flex">
              <router-link :to="{ name: 'login' }">
                <a class="txt">{{ $t("login.cancel") }}</a>
              </router-link>
              <a
                class="join smallFont hoverEffect"
                ref="loginButton"
                v-on:mouseover="formUtilsMouseHoverEffect($event, 'loginButton')"
                v-on:mouseout="formUtilsMouseHoverEffect($event, 'loginButton')"
                v-on:click.prevent="onSubmit()"
                href="javascript:void(0);"
              >
                <label>{{ $t("login.submit1") }}</label>
                <span
                  class="effect"
                  ref="effectLoginButton"
                  v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
                ></span>
                <img src="@/assets/images/nextArrowAnimation.svg" />
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import MasterHeader from '../partials/MasterHeader';
import { formUtilsCheckEmail, formUtilsMouseHoverEffect} from '@/utils/form_utils.js';

export default {
  
  data() {
    return {
      showToastError: false,
      showToastMessage: "",
      isEmailEmpty: true,
      
      form: {
        email: "",
        verificationCode: "",
        recaptchaToken: "",
      },

      errors: {
        email: false,
      },
      topX: 1,
      leftX: 1,
      recaptchaSiteKey: window.VUE_APP_RECAPTCHA_KEY,
    };
  },
  components: {
    MasterHeader
  },
  mounted() {
    this.$store.dispatch("app/loader", false);
  },
  methods: {
    formUtilsCheckEmail,
    formUtilsMouseHoverEffect,

    async onSubmit() {

      /* CHECK FIELDS BEFORE SUBMIT */
      this.formUtilsCheckEmail();
      if (this.errors.email) {
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    sendForm(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      this.$http
        .post("api/v1/passwordResetToken", {
          email: this.form.email,
        })
        .then(() => {
          this.$router.push({ path: "resetpasswordlinksent" });
        })
        .catch((e) => {
          if(e.body.message === 'Email does not exists'){
            this.showToastMessage = this.$t("error.email_not_found");    
          } else{
             this.showToastMessage = this.$t("error.invalid_update");
          }
          this.showToastError = true;   
        });
    }
  },
};
</script>
<style>
</style>